export const PROMO_TYPE_SLUG = 'btc-xmas';
